module.exports = __webpack_public_path__ + "images/external_images/svg/components/collaborative-user-research-blue-icon.svg";